import AxiosConfig from '../config/axiosConfigApiPlataform'

export const PlataformUserApi = {

  async getUser () {
    let response = await AxiosConfig.api().get('user')
    return response.data
  },

  async passwordResetSolicitation (email) {
    let response = await AxiosConfig.api().post('reset_password_without_token', {
      email: email,
      reset_url: process.env.VUE_APP_URL
    })
    return response.data
  }
}

export default PlataformUserApi
